export const SERVICES = {
    immo: 'IMMO',
    credit: 'Credit',
    // finance: 'Finance',
    lead: 'DATA&LEAD',
    // academy: 'Academie'
}

export const SERVICES_LOGO: any = {
    IMMO: 'HomeIcon',
    Credit: 'DollarSignIcon',
    // Finance: 'CreditCardIcon',
    'DATA&LEAD': 'HardDriveIcon',
    // Academie: 'PieChartIcon'
}